import React, { useState } from "react";
// import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { Button, ProgressBar, Spinner } from "react-bootstrap";
import { StarRating } from "@components";
import { ReviewModal } from "./ReviewModal";
import { useDispatch, useSelector } from "react-redux";
import { enrollAction } from "@redux/actions";
import styles from "./style/LearnType.module.css";
import clsx from "clsx";
import { useAccessControl } from "@hooks";

const LearnType = (props) => {
  const {
    courseId,
    isEnroll,
    isSaved,
    user,
    percentCompletion,
    myRating,
    onSave,
  } = props;
  // state
  const { isAuth } = useAccessControl();
  const { processing: enrollProcessing, courseId: courseIdEnroll } =
    useSelector((state) => state.enrollment.enroll);

  // variables

  // logics before hooks

  // hooks

  // logics
  const [showModalReview, setShowModalReview] = useState(false);

  const handleShowReview = () => {
    setShowModalReview(true);
  };

  const handleHideReview = () => {
    setShowModalReview(false);
  };

  // UI partials
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleEnroll = () => {
    if (!isAuth) {
      navigate("/sign-in");
    } else {
      const handleNavigateLearning = () => {
        navigate(`/learning/${courseId}`);
      };
      dispatch(enrollAction({ courseId, callback: handleNavigateLearning }));
    }
  };

  const handleLearn = () => {
    navigate(`/learning/${courseId}`);
  };
  // effects

  // render
  return (
    <div className=" my-learning-type">
      <div className="d-flex justify-content-between align-items-center">
        <Link
          className={styles.fs12}
          to={`/instructor-profile-view/${user?.id}`}
        >
          {user?.fullName || "Unknown author"}
        </Link>
        <span className={styles.fs12}>{`${percentCompletion}% complete`}</span>
      </div>
      <ProgressBar
        variant="danger"
        className="my-2"
        style={{ height: "0.3rem" }}
        now={percentCompletion}
        label={`${percentCompletion?.toFixed(2)}%`}
        visuallyHidden
      />
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="d-flex justify-content-between align-items-center">
          {isEnroll ? (
            <Button size="sm" variant="primary" onClick={handleLearn}>
              Learn
            </Button>
          ) : (
            <Button
              size="sm"
              variant="primary"
              onClick={handleEnroll}
              disabled={enrollProcessing && courseIdEnroll === courseId}
            >
              {enrollProcessing && courseIdEnroll === courseId && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="mr-2"
                />
              )}
              Enroll
            </Button>
          )}
          <button
            size="sm"
            onClick={onSave}
            className={styles.btnSave}
            // disabled={saveCourseProcessing}
          >
            {isSaved ? (
              <i className="bi bi-heart-fill" />
            ) : (
              <i className="bi bi-heart" />
            )}
          </button>
        </div>
        <span
          className={styles.ratingButton}
          onClick={isEnroll ? handleShowReview : handleEnroll}
        >
          <StarRating className={styles.fs12} numRating={myRating} />
          <div className={clsx(styles.fs12, "text-right")}>
            {!isEnroll
              ? "Enroll first"
              : myRating === 0
              ? "Leave a rating"
              : "Edit your rating"}
          </div>
        </span>
        {showModalReview && (
          <ReviewModal
            show={showModalReview}
            onClose={handleHideReview}
            courseId={courseId}
            myRating={myRating}
          ></ReviewModal>
        )}
      </div>
    </div>
  );
};

/* required: display name */
LearnType.displayName = "LearnType";

/* required: props types */
LearnType.propTypes = {};

/* required: default props */
LearnType.defaultProps = {};

export { LearnType };
